import Icon from '../components/Icon.vue'

Icon.register({
  'praying-hands': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M272 191.9C254.4 191.9 240 206.3 240 223.9V303.9C240 312.7 232.8 319.9 224 319.9S208 312.7 208 303.9V227.4C208 210 212.7 192.9 221.7 178L299.4 48.4C308.5 33.2 303.6 13.6 288.5 4.5 274-4.2 255.8 0.2 246.2 13.7 246 13.9 245.6 13.9 245.4 14.2L128.1 190.1C117.6 205.9 112 224.3 112 243.3V323.5L21.9 353.6A32-32 0 0 1 0 383.9V479.9C0 490.7 8.5 511.9 32 511.9 34.7 511.9 37.4 511.6 40.1 510.9L219.3 464.3C269.2 450 304 403.8 304 351.9V223.9C304 206.3 289.6 191.9 272 191.9zM618.1 353.6L528 323.6V243.4C528 224.4 522.4 206 511.9 190.1L394.6 14.3C394.4 14 394 14 393.8 13.8 384.3 0.3 366-4.1 351.5 4.6 336.4 13.6 331.5 33.3 340.6 48.5L418.3 178.1C427.3 193 432 210.1 432 227.4V304C432 312.8 424.8 320 416 320S400 312.8 400 304V224C400 206.4 385.6 192 368 192S336 206.4 336 224V352C336 403.9 370.8 450.1 420.8 464.3L599.9 511C602.6 511.6 605.3 512 608 512 631.5 512 640 490.8 640 480V384C640 370.2 631.2 358 618.1 353.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/praying-hands.js
// module id = 8mcu
// module chunks = 144